import React from 'react';
import { Box } from '@mui/material';

// The petcademy.org marketing bar for logged-out lesson pages (AC 6.3).
// Ported from the "Petcademy Public Lesson" Claude Design prototype: dark purple
// band, white wordmark on the left, uppercase nav on the right. Below the `wide`
// breakpoint the prototype swaps the nav for a single petcademy.org link.
const NAV_LINKS = [
  { label: 'For Rescues & Shelters', href: 'https://petcademy.org/solutions/rescues-shelters' },
  { label: 'For Pet Parents', href: 'https://petcademy.org/product' },
  { label: 'Pricing', href: 'https://petcademy.org/pricing' },
  { label: 'About', href: 'https://petcademy.org/about' },
  { label: 'Blog', href: 'https://petcademy.org/blog' },
  { label: 'Shop', href: 'https://shop.petcademy.org' },
];

const linkSx = {
  fontFamily: "'Lexend', system-ui, sans-serif",
  fontWeight: 500,
  fontSize: '13px',
  letterSpacing: '1.1px',
  textTransform: 'uppercase' as const,
  color: 'rgba(255,255,255,0.8)',
  textDecoration: 'none',
  whiteSpace: 'nowrap' as const,
  '&:hover': { color: '#fff' },
};

export default function PublicHeader() {
  return (
    <Box component="header" sx={{ background: '#23036A', flex: 'none' }}>
      <Box sx={{
        maxWidth: 1240,
        mx: 'auto',
        px: '28px',
        py: '16px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px 28px',
      }}
      >
        <Box
          component="a"
          href="https://petcademy.org"
          target="_blank"
          rel="noopener"
          title="Petcademy home"
          sx={{
            flex: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            textDecoration: 'none',
            '&:hover': { opacity: 0.8 },
          }}
        >
          <Box
            component="img"
            src="/petcademy-wordmark-white.svg"
            alt="Petcademy"
            sx={{ height: 32, display: 'block' }}
          />
        </Box>

        <Box
          component="nav"
          aria-label="Petcademy"
          sx={{
            display: { xs: 'none', md: 'flex' },
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '12px 22px',
          }}
        >
          {NAV_LINKS.map((link) => (
            <Box
              key={link.href}
              component="a"
              href={link.href}
              target="_blank"
              rel="noopener"
              sx={linkSx}
            >
              {link.label}
            </Box>
          ))}
        </Box>

        <Box
          component="a"
          href="https://petcademy.org"
          target="_blank"
          rel="noopener"
          sx={{
            ...linkSx,
            display: { xs: 'inline-flex', md: 'none' },
            alignItems: 'center',
            gap: '6px',
            letterSpacing: '0.6px',
            textTransform: 'none',
            color: 'rgba(255,255,255,0.9)',
          }}
        >
          petcademy.org
        </Box>
      </Box>
    </Box>
  );
}
